import React from 'react';

import { EBadgeType } from 'common/contracts';
import {
  getBadgeLabel,
  getBadgePlaceholder,
  shouldRenderBadge
} from 'views/Offers/Offer.utils';
import InputSelectDropdown from 'components/InputSelectDropdown/InputSelectDropdown';
import RichText from 'components/RichText/RichText';

interface IBadgesSectionProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  values: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setFieldValue: (field: string, value: any) => void;
  relevantBadgeType: EBadgeType | 'both';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  badgeList: any[];
}

export const BadgesSection: React.FC<IBadgesSectionProps> = ({
  values,
  setFieldValue,
  relevantBadgeType,
  badgeList
}): React.ReactElement | null => {
  if (!shouldRenderBadge(relevantBadgeType)) {
    return null;
  }

  return (
    <>
      <RichText
        className="mb-5"
        title="Badges"
        description='Highlight your offer with a badge like "Most Popular" or "Best Value"'
      />
      <div className="grid grid-cols-2 gap-5">
        <InputSelectDropdown
          key={`badge-${values.badge || 'none'}`}
          label={getBadgeLabel(relevantBadgeType)}
          placeholder={getBadgePlaceholder(relevantBadgeType)}
          buttonDataTestId="promoBadgesInpt"
          options={[
            { value: '', label: 'None' },
            ...(badgeList?.map((item: { value: string; content: string }) => ({
              value: item.value,
              label: item.content
            })) || [])
          ]}
          defaultSelected={
            values.badge
              ? badgeList?.find(
                  (item: { value: string }) => item.value === values.badge
                )
                ? {
                    value: values.badge,
                    label:
                      badgeList.find(
                        (item: { value: string }) => item.value === values.badge
                      )?.content || ''
                  }
                : undefined
              : undefined
          }
          onOptionChange={(value) =>
            setFieldValue('badge', value === '' ? null : value)
          }
        />
        <InputSelectDropdown
          label="Position"
          disabled
          options={[]}
          defaultSelected={{
            value: 'Left',
            label: 'left'
          }}
        />
      </div>
    </>
  );
};
